import { Outlet } from "react-router";

export const AuthWrapper = () => {
  console.log('Working')
  return (
    <Outlet />
  );
};
